export const getModules = (permissions) => {
    return permissions ? permissions.map(item => ({
      module: item.title,
      access: ['create', 'read', 'update', 'delete']
    })) : [];
  };
  